import {Component, OnInit} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {Router} from '@angular/router';
import {RouterService} from '../RouterService';
import { environment } from '../../environments/environment';

declare var initScript: any;

@Component({
    selector: 'app-location',
    templateUrl: './location.component.html',
    styleUrls: ['./location.component.css']
})
export class LocationComponent implements OnInit {

    title = 'Location';
    brochureURL;

    constructor(private titleService: Title) {
        titleService.setTitle(this.title);
        this.brochureURL = environment.brochureURL;
    }

    ngOnInit(): void {
    }

}
